module.exports = __webpack_public_path__ + "img/businessman.7df09a56.svg";